/**
 * This surface's entry point.
 *
 * Every prerendered page ships this same bundle and hydrates whichever route its own URL matches.
 * The content is already in the HTML — this makes the forms work.
 */
import { StrictMode } from "react"
import { hydrateRoot, createRoot } from "react-dom/client"
import "@agitome/ui-shared/styles/tokens.css"
// The shared lead gate's structure. No colour of its own — every value is a var() on the
// tokens imported above, so it inherits this product's palette by loading after them.
import "@agitome/ui-shared/leadgate.css"
import { startAnalytics, trackPage } from "@agitome/ui-shared"
import { match } from "./routes"

const route = match(window.location.pathname)

// ONE VIEW PER DOCUMENT, not a route-change subscription. These pages are prerendered and
// server-served: each URL is its own document and there is no client-side navigation between
// them, so a pageview happens exactly once, here, on load. Cookieless — these are public pages.
startAnalytics({ cookieless: true })
trackPage(window.location.pathname)
const root = document.getElementById("root")!
const Page = route?.element

if (!Page) {
  // No client route for this URL — the normal, correct state for the two pages FastAPI renders at
  // request time (/incidents/{slug}, /risk-reports/{id}). They are complete documents and there is
  // nothing here to hydrate, so this leaves them alone. It once rendered "Not found." over them,
  // which meant the most-shared URL in the product served a correct page and then had JavaScript
  // erase it a moment later.
} else if (root.hasChildNodes()) {
  hydrateRoot(root, <StrictMode><Page /></StrictMode>)
} else {
  // A dev-server load has an empty root and mounts fresh.
  createRoot(root).render(<StrictMode><Page /></StrictMode>)
}
